<af-main-container [title]="'i18n_af_adminPanel' | translate"
                   [showBreadcrumbs]="false"
                   [showBackButton]="false"
                   [buttonLabel]="buttonText | translate"
                   (buttonClickListener)="buttonClickSubject.next(activeTab)">
    <mat-tab-group mat-align-tabs="start" animationDuration="0"
                   class="mt-16 w-100 h-100 hide-scroll-bar"
                   [(selectedIndex)]="selectedTabIndex"
                   (selectedIndexChange)="handleNavigation($event)">
        @for (tab of tabs; track tab) {
            <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                <ng-template matTabContent>
                    @if (tab === 'tabDictionaries' && activeTab === tab) {
                        <af-dictionary #tab
                                       [buttonClickStream]="buttonClickSubject"
                                       (changeButtonText)="handleButtonTextChanges($event)"/>
                    }
                    @if (tab === 'tabOrganizations' && activeTab === tab) {
                        <af-organizations #tab
                                          [buttonClickStream]="buttonClickSubject"
                                          (changeButtonText)="handleButtonTextChanges($event)"/>
                    }
                    @if (tab === 'tabUsers' && activeTab === tab) {
                        <af-users #tab
                                  [buttonClickStream]="buttonClickSubject"
                                  (changeButtonText)="handleButtonTextChanges($event)"/>
                    }
                    @if (tab === 'tabJobs' && activeTab === tab) {
                        <af-jobs #tab/>
                    }
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</af-main-container>
